<script>
    import FixedButtons from './components/FixedButtons.svelte';
    import ChartsSelector from './components/ChartsSelector.svelte';
    import {onMount} from 'svelte';
    import router from 'page';

    import Loader from "./components/Loader.svelte";
    import MonthSelector from './components/MonthSelector.svelte';
    import NavBar from './components/NavBar.svelte';
    import OrgSelector from './components/OrgSelector.svelte';
    import ReportMenus from './components/ReportMenus.svelte';
    import YearSelector from './components/YearSelector.svelte';
    import RollingMonthsSelector from './components/RollingMonthsSelector.svelte';

    import Dashboard from './pages/Dashboard.svelte';
    import HR from './pages/HR.svelte';
    import Error from './pages/Error.svelte';
    import Help from './pages/Help.svelte';
    import Login from './pages/Login.svelte';
    import Permissions from './pages/Permissions.svelte';
    import TrashBin from './pages/TrashBin.svelte';
    import AlteryxCatalog from './pages/AlteryxCatalog.svelte';

    import Weekly from './pages/Weekly.svelte';
    import Home from './pages/Home.svelte';
    import Monthly from './pages/Monthly.svelte';
    import Employees from './pages/Employees.svelte';
    import Charts from './pages/Charts.svelte';
    import Sdr from './pages/Sdr.svelte';

    import menusService from './services/menus.service.js';
    import AuthService from './services/auth.service.js';
    import OrganizationsService from "./services/organizations.service";
    import WeekDaySelector from "./components/WeekDaySelector.svelte";
    import ReportsService from "./services/reports.service";
    import CookiesService from './services/cookies.service.js';
    import ApiSettings from './pages/ApiSettings.svelte';
    import TalentTracking from './pages/TalentTracking.svelte';
    import TalentTrackingPermissions from './pages/TalentTrackingPermissions.svelte';
    import ResetPassword from './pages/ResetPassword.svelte';

    let page, params, user, loading = true,
        organizations, options, showMenu = false, staticPage = false,
        buildNumber = window.buildNumber, hrDisabledUsers = [], organizationsCodes, component, talentTrackingFilters;
    let selectedActivity = 'employee';
    let roles = [];

    //Org and menu are objects and the other are strings
    $: options = {
        'org': {
            'id': '',
            'name': '',
            'is_active': null
        },
        'weekday': 1,
        'year': '',
        'month': '',
        'rollingMonth': null,
        'menu': {
            'title': '',
            'url': '',
            'default': '',
            'subMenus': []
        },
        'subMenu': '',
        'chartOrgs': ""
    };

    $: organizations = [];

    //Get org data from org param
    function getOrg(orgId) {
        var org = organizations.filter((o) => o.id == orgId);
        return (org.length == 1) ? org[0] : organizations[0];
    }

    //Get report type as object from param
    function getMenu(urlParam) {
        var menu = menusService.filter((m) => m.url == urlParam);
        return (menu.length == 1) ? menu[0] : menusService[0];
    }

    //Get report sub type as string
    function getSubMenu(param) {
        var subMenu = options.menu.subMenus.filter((s) => s.url == param);
        return (subMenu.length == 1) ? subMenu[0].url : options.menu.default;
    }

    function loadParams() {
        var today = new Date();

        if (!params) {
            if (organizations[0]) {
                options = {
                    'org': organizations[0],
                    'year': today.getFullYear(),
                    'month': today.getMonth() +1,
                    'rollingMonth' : null,
                    'menu': null,
                    'subMenu': menusService[0].default.replace('/', ''),
                    'weekday': 1,
                    'chartOrgs': organizations[0].id.toString()
                }
            }
        } else {
            //Assign org
            options.org = getOrg(params.org);

            //Assign year
            if (params.year == today.getFullYear() || params.year == today.getFullYear() - 1) {
                options.year = params.year;
            } else {
                options.year = today.getFullYear();
            }

            //Assign month
            if (params.month > 0 && params.month < 13) {
                options.month = params.month;
            } else {
                options.month = today.getMonth();
            }

            //Get menu as object
            var urlPathName = window.location.pathname.split('/')[1];
            options.menu = getMenu(urlPathName);

            //Asign subMenu
            options.subMenu = getSubMenu(params.subMenu);

            //Asign chart orgs list
            if(options.menu.url == "charts"){
                options.chartOrgs = params.org;
            }

            options.rollingMonth = params.ptqr_rolling_month;
        }

        // RRAS Tasks / Export
        let lmsOrg, orgFound;
        if (lmsOrg = CookiesService.get('rras_export_org')) {
            if( orgFound = organizations.filter((o) => o.lms_id == lmsOrg)) {
                CookiesService.set('rras_export_org','',365);
                // Redirect to rras organization
                let newUrl = window.location.href.split('/');
                newUrl[4] = orgFound[0].id;
                window.location.href = newUrl.join('/');
            }
        }
    }

    onMount(async () => {
        await AuthService.init();
        user = AuthService.getUser();

        if (user.id) {
            await OrganizationsService.init();
            organizations = OrganizationsService.list();
            AuthService.setOrganizations(organizations);
            let orgCodesResponse = null;
            orgCodesResponse = await OrganizationsService.getOrganizationsCodes();
            if(orgCodesResponse && orgCodesResponse.data) organizationsCodes = orgCodesResponse.data;
            loadParams();
        }

        loading = false;
    });

    function logout() {
        organizations = false;
        user = undefined;
        loading = true;
        AuthService.logout();
    }

    function intercept(ctx, next) {
        params = ctx.params;
        showMenu = true;
        next();
    }

    function startDayChanged(){
        params.subMenu = "1";
        params.subMenu = "";
    }

    function rollingMonthChanged(subMenu) {
        params.subMenu = subMenu;
    }

    // General routes
    router('/', () => {
        if (window.location.href.indexOf('?v=') > 0) {
            page = Dashboard;
            showMenu = true;
        } else {
            window.location = '/?v=' + Math.floor(Date.now() / 1000);
        }
    });

    router('/dashboard', () => {
        page = Dashboard;
        showMenu = true;
        var today = new Date();
        options = {
            'org': organizations && organizations[0]? organizations[0]: 0,
            'year': today.getFullYear(),
            'month': today.getMonth(),
            'menu': null,
            'subMenu': menusService[0].default.replace('/', ''),
            'weekday': 1,
        };
    });

    router('/permissions', () => {
        showMenu = false;
        page = Permissions;
    });

    router('/trashbin',
        (ctx, next) => {
            params = ctx.params;
            showMenu = false;
            next();
        },
        () => page = TrashBin);

    router('/alteryx',
        (ctx, next) => {
            params = ctx.params;
            showMenu = false;
            next();
        },
        () => page = AlteryxCatalog);
    router('/api-settings',
        (ctx, next) => {
            params = ctx.params;
            showMenu = false;
            next();
        },
        () => page = ApiSettings);
    router('/talent-tracking',
        (ctx, next) => {
            params = ctx.params;
            showMenu = false;
            next();
        },
        () => page = TalentTrackingPermissions);

    // Authentication
    router('/logout', logout);
    router('/login', () => {
        page = Login;
    });
    router('/reset-password/:token', intercept, () => page = ResetPassword);

    // Reports routes
    router('/weekly/:org?/:year?/:month?', intercept, () => page = Weekly);
    router('/monthly/:org?/:subMenu?/:year?/:month?', intercept, () => page = Monthly);
    router('/employees/:org?/:subMenu?/:year?/:month?', intercept, () => page = Employees);
    // Charts
    router('/charts/:org?/:subMenu?/:year?/:month?', intercept, () => page = Charts);
    // HR reports
    router('/hr/:org?/:subMenu?/:year?/:month?', intercept, () => page = HR);
    // SDR
    router('/sdr/:org?/:year?/:month?', intercept, () => page = Sdr);
    // Talent Tracking
    router('/talent_tracking/:org?/:year?/:month?', intercept, () => page = TalentTracking);

    //Riverside home page
    router('/home', () => {
        staticPage = true;
        page = Home;
    });
    // Documentation routes
    router('/help/:section',
        (ctx, next) => {
            params = ctx.params;
            showMenu = false;
            next();
        },
        () => page = Help);

    // Not found / Error route
    router('/*', (ctx, next) => {
            params = ctx.params;
            showMenu = false;
            next();
        },
        () => page = Error);
    router.start();

    async function pasteController() {
        let data = jQuery('#pasteController').data();
        if (data.paste) {
            if (jQuery('.hr-report').length > 0){
                //Paste HR data
                console.log(data.paste);
                await ReportsService.hrPasting(data.paste, params.org);
                jQuery('#reloadData').trigger('click');
            } else {
                //Paste KPIS data
                let payload = [];
                let report = '';

                data.paste.map( cell => {
                    let newCell = {
                        date: cell.date,
                        locked: false,
                        notes: 'pasted'
                    };

                    if (cell.field) {
                        report = cell.report;
                        if (cell.field === 'actual') newCell.actual = cell.value;
                        if (cell.field === 'yearly_actuals') newCell.actual = cell.value;
                        if (cell.field === 'budget') newCell.budget = cell.value;
                        if (cell.field === 'performance') newCell.performance = cell.value;
                        if (cell.field === 'quota') newCell.quota = cell.value;
                        if (cell.field === 'pipeline') newCell.pipeline = cell.value;

                        if (cell.report === 'employee') {
                            newCell.employee_id = cell.id;
                            if(cell.attainment_header){
                                newCell.field = cell.field;
                                newCell.value = cell.value;
                            }
                        } else {
                            newCell.kpi_id = cell.id;
                        }

                        payload.push(newCell);
                    }
                });

                await ReportsService.paste(payload, report, params.org);
                jQuery('#reloadData').trigger('click');
            }
        }
    }

    function selectActivity(event) {
        selectedActivity = event.detail;
    }

    function onRolesLoaded(event) {
        roles = event.detail;
    }
</script>
<button id="pasteController" style="display: none;" on:click={pasteController}>PASTE</button>

{#if !staticPage}
    <NavBar bind:user={user}></NavBar>
    <div id="main-div" class="px-3">
        {#if loading}
            <Loader></Loader>
        {:else}
            {#if user && showMenu == true }
                <ReportMenus menus={menusService} bind:options={options} bind:params={params} />
                {#if options.menu}
                    <div class="row pb-3" id="report-options">
                        <div class="col">
                            <div class="row">
                                {#if options.menu.url == 'charts'}
                                    <ChartsSelector bind:options={options} bind:params={params} />
                                {/if}

                                {#if params && window.location.pathname.split('/')[3] !== 'staffing-agregate' && window.location.pathname.split('/')[1] !== 'talent_tracking'}
                                    <OrgSelector codes={organizationsCodes} organizations={organizations} bind:options={options} bind:params={params} />
                                {:else if window.location.pathname.split('/')[3] !== 'staffing-agregate'}
                                    <div class="offset-2 col-md-3 mt-3">
                                        <div id="dropdownOrganizations" class="btn text-left">ALL PORTCO'S</div>
                                    </div>
                                {/if}

                                {#if params && (window.location.pathname.split('/')[1] == 'weekly')}
                                    {#if AuthService.can('SHOW_WEEKDAY_SELECTOR') }
                                        <WeekDaySelector bind:options={options} on:dayChanged={ () => startDayChanged() } />
                                    {/if}
                                {/if}

                                {#if params && window.location.pathname.split('/')[1] !== 'talent_tracking'}
                                    <YearSelector bind:options={options} />
                                {/if}

                                {#if window.location.pathname.split('/')[1] === 'weekly' ||
                                (params && ['summary', 'last_12_months'].includes(params.subMenu) && 'monthly' === window.location.pathname.split('/')[1])}
                                    <MonthSelector bind:options={options} />
                                {/if}
                                {#if params && (['ptqr'].includes(window.location.pathname.split('/')[3]))}
                                    <RollingMonthsSelector
                                        bind:options={options}
                                        on:monthChanged={ () => rollingMonthChanged(window.location.pathname.split('/')[3])}
                                    />
                                {/if}

                            </div>
                        </div>
                    </div>
                    {#if params && (window.location.pathname.split('/')[1] != 'hr')}
                        <FixedButtons
                            roles={roles}
                            bind:params={params}
                            bind:component={component}
                            bind:talentTrackingFilters
                            on:selectActivity={selectActivity}
                            on:exportReport={(report) => component.exportToExcel(report.detail.all_portcos)}
                            on:indicatorsRemoved={component.loadData}
                            on:addSection={component.addSection}
                            on:addEmployee={component.addEmployee}
                            on:importModal={component.openImportModal}
                            on:selectEntries={(data) => component.selectEntries(data.detail.entries)}
                            on:search={(data) => component.onSearch(data.detail.search)}
                            on:roleFilter={(data) => component.onRoleFilter(data.detail.role)}
                        ></FixedButtons>
                    {/if}
                {/if}
            {/if}
            {#if params && (window.location.pathname.split('/')[1] != 'hr')}
                <div id="{(user && showMenu == true) ? 'reportsDiv': ''}" class="{(params) ? (window.location.pathname.split('/')[1] == 'weekly'? 'reports-weekly' : ''):'reports-dashboard'}">
                    <svelte:component this={page}
                                      on:loaded={onRolesLoaded}
                                      bind:this={component} params={params}
                                      bind:user={user} bind:options={options}
                                      bind:talentTrackingFilters
                                      bind:selectedActivity={selectedActivity}></svelte:component>
                </div>
            {:else}
                <!-- Use reportDiv inside HR component / page -->
                <svelte:component this={page} bind:this={component} params={params} bind:user={user} bind:options={options}></svelte:component>
            {/if}
        {/if}
    </div>

    <footer class="text-center text-muted" on:click={() => window.location = '/?v=' + Date.now()}>
        <small>Copyright 2025 Riverside Company - v{buildNumber}</small>
    </footer>

{:else}
    <svelte:component this={page} bind:this={component} params={params}></svelte:component>
{/if}
